import { IYoutubeSearchResult } from 'motw_core/YouTube/IYoutubeSearchResult';
import * as React from 'react';
import { YoutubeDownloadLinkIcon } from 'source/app/presentation/MainPanel/DevTools/Youtube/Search/Results/SingleResult/Download/YoutubeDownloadLinkIcon';

export function ShowSingleYoutubeSearchResult({
	searchResult
}: {
	searchResult: IYoutubeSearchResult;
}) {
	return (
		<div style={{ padding: `5px` }}>
			<a href={searchResult.link} title={searchResult.title}>
				<span>{searchResult.title}</span>
				<img
					style={{ maxWidth: `50px`, marginLeft: `15px` }}
					src={searchResult.thumbnail.url}
				/>
			</a>
			<YoutubeDownloadLinkIcon searchResult={searchResult} />
		</div>
	);
}
